export default "* Hvordan tror I man kunne tænde lys inde i hulen i jægerstenalderen?\n* Hvordan tænder I lys i jeres hjem?";